// extracted by mini-css-extract-plugin
module.exports = {"selectPopUp":"selectPopUp__1ut3X","popUpBody":"popUpBody__1AGS2","spinner":"spinner__1Ne8J","action":"action__2p5zs"};